<!-- Center canvas: summary, text typed into directly, matches the other always-visible v2 blocks' badge+card pattern -->
<div
  class="cr-oc-card"
  *ngIf="isPreview"
  [id]="block.blockId"
>
  <span class="cr-oc-badge">Only CTA</span>

  <a class="cr-oc-cta" [href]="previewHref" target="_blank" rel="noopener">
    <span
      [appInlineEdit]="block.variables?.OnlyCtaText ?? ''"
      [inlineEditBlockId]="block.blockId"
      [inlineEditPlaceholder]="ctaButtonPlaceholder"
      (inlineEditChange)="onChange($event, 'OnlyCtaText')"
    ></span>
  </a>
</div>

<!-- Right panel: real edit form -->
<div class="cr-oc-edit" *ngIf="!isPreview">
  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.OnlyCtaText ?? ''"
    (handleOnChange)="onChange($event, 'OnlyCtaText')"
    [placeholder]="onlyCtaTextPlaceholder"
    [maxLength]="30"
    variable="OnlyCtaText"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <div class="cr-oc-link-field">
    <app-field-editor-v2
      type="action-link"
      [blockData]="block.variables?.OnlyCtaLink ?? ''"
      (handleOnChange)="onChange($event, 'OnlyCtaLink')"
      [placeholder]="onlyCtaLinkPlaceholder"
      [maxLength]="500"
      variable="OnlyCtaLink"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'OnlyCtaLinkSegmentRegex')"
      [selectedSegment]="block.variables?.OnlyCtaLinkSegmentRegex ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>
</div>
